import { Button, Col, Form, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Select from "react-select"


export default function ProductForm({
        submit, formState, restaurants, handleInputChange, handleSelect,
        handleSelectChange, handleCheckboxChange, handleRestaurantPriceChange, handleRestaurantSupplementChange, handleImage,
        allergensTextIcons, isRegistering, imageAux, isAddingOrEditing}) {
    const { t } = useTranslation()

    return (
        <Form className="px-4 formulario" onSubmit={submit}>
            <Row>
                <Col xs={12} md={6}>
                    <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.products.typeproduct')}*</h2>
                        <select className="select-adminproducttype form-control" value={formState?.type || ''} onChange={handleSelect}>
                            <option value='Dish' className="sd-label-medium">{t('admin.products.dish')}</option>
                            <option value='Drink' className="sd-label-medium">{t('admin.products.drink')}</option>
                            <option value='Dessert' className="sd-label-medium">{t('admin.products.dessert')}</option>
                        </select>
                    </Row>
                    <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.products.nameproduct')}*</h2>
                        <Form.Control
                            className="sd-input"
                            type='text'
                            name='name'
                            value={formState.name ||  ''}
                            placeholder={t('admin.products.setname')}
                            onChange={handleInputChange}
                            required
                        />
                    </Row>
                    <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.products.allergensproduct')}*</h2>
                        <Select
                            className="text-start p-0"
                            isMulti
                            name={'allergen'}
                            options={allergensTextIcons}
                            value={formState?.allergens}
                            onChange={(e) => handleSelectChange(e)}
                            required
                        />
                    </Row>
                    {/* <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.products.supplementproduct')}*</h2>
                        <Form.Control
                            className="sd-input"
                            type='number'
                            name='supplement'
                            value={formState.supplement ||  ''}
                            placeholder={t('admin.products.setsupplement')}
                            onChange={handleInputChange}
                            required
                        />
                    </Row> */}
                    <Row className="my-3 border-2 border p-2">
                        <h2>{t('admin.products.supplementproduct')}</h2>
                        <Row>
                        {restaurants?.map((restaurant) => (
                            <Col key={restaurant._id} xs={12} md={6}>
                                <Form.Label>{restaurant.name}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type="number"
                                    name={`supplement_${restaurant._id}`}
                                    value={
                                        formState?.supplements?.find(price => price.restaurant === restaurant._id)?.price || ''
                                    }
                                    placeholder={t('admin.products.setprice')}
                                    onChange={(e) =>
                                        handleRestaurantSupplementChange(restaurant._id, e.target.value)
                                    }
                                />
                            </Col>
                        ))}
                        </Row>
                    </Row>

                    {/* <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.products.priceproduct')}{formState.isComplement ? '*' : ''}</h2>
                        <Form.Control
                            className="sd-input"
                            type='number'
                            name='price'
                            value={formState.price ||  ''}
                            placeholder={t('admin.products.setprice')}
                            onChange={handleInputChange}
                            required={formState.isComplement}
                        />
                    </Row> */}
                    <Row className="my-3 border-2 border p-2">
                        <h2>{t('admin.products.priceproduct')}</h2>
                        <div className="form-check">
                            <input className="form-check-input" id="active_campaign" type='checkbox' value='isComplement' onChange={handleCheckboxChange} checked={formState.isComplement || false} />
                            <h2 className="sd-label text-start fs-16 fw-400" htmlFor="active_campaign">{t('admin.products.iscomplement')}</h2>
                        </div>
                        <Row>
                        {restaurants?.map((restaurant) => (
                            <Col key={restaurant._id} xs={12} md={6}>
                                <Form.Label>{restaurant.name}</Form.Label>
                                <Form.Control
                                    className="sd-input"
                                    type="number"
                                    name={`price_${restaurant._id}`}
                                    value={
                                        formState?.prices?.find(price => price.restaurant === restaurant._id)?.price || ''
                                    }
                                    placeholder={t('admin.products.setprice')}
                                    onChange={(e) =>
                                        handleRestaurantPriceChange(restaurant._id, e.target.value)
                                    }
                                />
                            </Col>
                        ))}
                        </Row>
                    </Row>
                </Col>
                <Col xs={12} md={6} className="my-3">
                    <h2 className="sd-label text-start fs-16 fw-400">{t('admin.products.setimage')}</h2>
                    <Form.Control
                        className="sd-input"
                        type='file'
                        name='image'
                        value={formState.image || ''}
                        onChange={handleImage}
                    />
                    {imageAux
                        ?
                            <img className="img-profile w-100 mt-4" alt="Preview" src={typeof imageAux === 'string' ? imageAux : URL.createObjectURL(imageAux)} />
                        :
                            formState.photo
                                ?
                                    <img className="img-profile w-100 mt-4" alt="Preview" src={typeof formState.photo === 'string' ? formState.photo : URL.createObjectURL(formState.photo)} />
                                :
                                    <div className="img-profile w-100 mt-4"></div>
                    }
                </Col>
            </Row>
            <Row className="text-center my-3">
                <Col>
                    <Button variant='primary' type="submit" className="btn-primary w-100 my-2">
                    {isRegistering
                        ?
                            <>
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </>
                        :
                            isAddingOrEditing==='adding' ? <>{t('admin.products.register')}</> : <>{t('admin.products.update')}</>
                    }
                    </Button>
                </Col>
            </Row>
        </Form>

    )
}